<template>
  <div style="width: 100%; min-height: 100vh; background: rgb(237, 241, 255)">
    <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background-color: #ede9e7" title="新增支付宝账号" left-arrow @click-left="$router.back()" />
    <div style="height: 46px"></div>
    <div class="usrse">
      <div class="hgs">
        <div class="nams">真实姓名</div>
        <div>
          <van-cell-group>
            <van-field v-model="cardInfo.bank_owner" type="text" placeholder="请输入支付宝实名姓名"> </van-field>
          </van-cell-group>
        </div>
      </div>
    </div>
    <div style="font-size: 0.24rem; color: #98a5b3; text-align: center; box-sizing: border-box; padding: 6px">为了您的资金能够迅速到账，请确保填写的姓名与支付宝实名一致</div>
    <div class="usrse">
      <div class="hgs">
        <div class="nams">支付宝账号</div>
        <div style="border-bottom: 1px solid #f2f2f2">
          <van-cell-group>
            <van-field v-model="cardInfo.bank_no" type="text" placeholder="请输入支付宝账号（手机号/邮箱）"> </van-field>
          </van-cell-group>
        </div>
      </div>
      <div class="hgs">
        <div class="nams">支付密码</div>
        <div style="border-bottom: 1px solid #f2f2f2">
          <van-cell-group>
            <van-field v-model="cardInfo.pay_pass" type="password" placeholder="请输入支付密码" />
          </van-cell-group>
        </div>
      </div>
      <van-button type="info" style="margin-top: 20px; width: 100%" @click="bindCard">确认添加</van-button>
      <div style="height: 60px"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'addAlipayCard',
  data() {
    return {
      cardInfo: { bank: '支付宝' },
    };
  },
  created() {},
  methods: {
    bindCard() {
      let that = this;
      let cardInfo = that.cardInfo;
      cardInfo.bank = '支付宝';
      if (!cardInfo.bank_owner) {
        that.$parent.showTost(0, '请输入真实姓名');
        return;
      }
      if (!cardInfo.bank_no) {
        that.$parent.showTost(0, '请输入支付宝账号');
        return;
      }
      if (!cardInfo.pay_pass) {
        that.$parent.showTost(0, '请输入支付密码');
        return;
      }
      if (cardInfo.pay_pass.length < 6 || cardInfo.pay_pass.length > 18) {
        that.$parent.showTost(0, '请输入正确的支付密码长度');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bindcard', cardInfo)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, '绑定成功');
            that.$router.back();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.usrse {
  background: #fff;
  box-sizing: border-box;
  padding: 6px 20px 0;
  .nams {
    font-size: 0.38rem;
    color: #000;
    vertical-align: middle;
    margin-top: 10px;
    font-weight: 700;
  }
}
[class*='van-hairline']:after {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/addAlipayCard.vue